import React from "react";
import "./spinner.scss";

function Spinner() {
  return (
    <div className="spinner">
      <i />
      <i />
      <i />
      <i />
      <i />
      <i />
      <i />
    </div>
  );
}

export default Spinner;
